import {
  Component,
  Input,
  HostBinding,
  ElementRef,
  Renderer2,
  DoCheck,
  SimpleChanges,
  OnChanges,
  OnInit,
  ViewEncapsulation,
} from '@angular/core';
import { PgPalette } from '../core/ui/palette';

@Component({
  selector: 'pg-icon, grit-icon',
  templateUrl: './pg-icon.component.html',
  styleUrls: ['./pg-icon.component.scss'],
  exportAs: 'pgIcon, gritIcon',
})
export class PgIconComponent implements OnChanges, OnInit {
  @Input()
  size?: number;

  @Input()
  color: PgPalette = 'default';

  @Input() foregroundColor: string;
  @Input() backgroundColor: string;

  @Input()
  mode: 'default' | 'border' = 'default';

  @HostBinding('style.font-size')
  get _styleFontSize() {
    if (this.size) {
      return `${this.size}px`;
    } else if (this.mode === 'border') {
      return '10px';
    }
    return '24px';
  }

  @HostBinding('class.grit-icon')
  @HostBinding('class.pg-icon')
  readonly _classPgIcon: true = true;

  @HostBinding('class.material-icons')
  readonly _classMatIcon: true = true;

  get hostEl(): HTMLElement {
    return this.elementRef.nativeElement;
  }

  constructor(public elementRef: ElementRef, public renderer: Renderer2) {}

  ngOnInit() {
    this.renderer.addClass(this.hostEl, `mode-${this.mode}`);
    this.renderer.addClass(this.hostEl, this.color);
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.mode && !changes.mode.firstChange) {
      this._replaceClass(
        `mode-${changes.mode.previousValue}`,
        `mode-${changes.mode.currentValue}`
      );
    }
    if (changes.color && !changes.color.firstChange) {
      this._replaceClass(
        changes.color.previousValue,
        changes.color.currentValue
      );
    }
  }

  private _replaceClass(oldVal, newVal) {
    this.renderer.removeClass(this.hostEl, oldVal);
    if (newVal) {
      this.renderer.addClass(this.hostEl, newVal);
    }
  }
}
